import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Spin,
  Statistic,
  Table,
  Tooltip,
  Typography,
} from "antd";

import {
  DeleteOutlined,
  DownOutlined,
  PlusOutlined,
  RightOutlined,
} from "@ant-design/icons";

//PROJECT IMPORTS
import dayjs from "dayjs";
import "../../../../assets/styles/DatePicker.css";
import styles from "../../../../assets/styles/styles";
import { showCheckerApprovalModal } from "../../../../components/CheckerModal";
import CustomButton from "../../../../components/custom/CustomButton";
import MainLayout from "../../../../components/layouts/MainLayout";
import TopContent from "../../../../components/layouts/TopContent";
import appLabel from "../../../../config/appLabel";
import appStatic from "../../../../config/appStatic";
import definedApi from "../../../../services/definedApi";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../customer/customer.config";
import MapFees from "../../casa/components/casaForms/accountingForm/MapFees";
import MapPenalties from "../../casa/components/casaForms/accountingForm/MapPenalties";
import ConfigureFundSource from "../components/ConfigureFundSource";
import InterestRateChart from "./EditInterestChart";

const { Text, Title } = Typography;

const EditPRD0500 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const [liabilityAccountOptions, setLiabilityAccountOptions] = useState([]);
  const navigate = useNavigate();
  const { state } = useLocation();
  const [chargesOptions, setChargesOptions] = useState([]);
  const [interestPostingPeriodType, setInterestPostingPeriodType] = useState();
  const [currencyData, setCurrencyData] = useState([]);
  const [
    interestCompoundingPeriodTypeOptions,
    setInterestCompoundingPeriodTypeOptions,
  ] = useState([]);
  const [
    interestPostingPeriodTypeOptions,
    setInterestPostingPeriodTypeOptions,
  ] = useState([]);
  const [interestCalculationTypeOptions, setInterestCalculationTypeOptions] =
    useState([]);
  const [
    interestCalculationDaysInYearTypeOptions,
    setInterestCalculationDaysInYearTypeOptions,
  ] = useState([]);
  const [
    lockinPeriodFrequencyTypeOptions,
    setLockinPeriodFrequencyTypeOptions,
  ] = useState([]);
  const [periodFrequencyTypeOptions, setPeriodFrequencyTypeOptions] = useState(
    [],
  );
  const [interestRateTableSource, setInterestRateTableSource] = useState([]);
  const [forPrematureClosure, setForPrematureClosure] = useState();
  const [minDepositTypeOptions, setMinDepositTypeOptions] = useState([]);
  const [maxDepositTypeOptions, setMaxDepositTypeOptions] = useState([]);
  const [
    inMultiplesOfDepositTermTypeOptions,
    setInMultiplesOfDepositTermTypeOptions,
  ] = useState([]);
  const [
    preClosurePenalInterestOnTypeOptions,
    setPreClosurePenalInterestOnTypeOptions,
  ] = useState([]);
  const [
    preClosurePenalInterestStrategyOptions,
    setPreClosurePenalInterestStrategyOptions,
  ] = useState([]);
  const [taxGroupOptions, setTaxGroupOptions] = useState([]);
  const [configureFundTableSource, setConfigureFundTableSource] = useState([]);
  const [mapFeeTableSource, setMapFeeTableSource] = useState([]);
  const [mapPenaltyTableSource, setMapPenaltyTableSource] = useState([]);
  const [periodTypeOptions, setPeriodTypeOptions] = useState([]);
  const [showAdvancedAccounting, setShowAdvancedAccounting] = useState(false);
  const [chargeList, setChargeList] = useState([]);
  const [expenseAccountOptions, setExpenseAccountOptions] = useState([]);
  const [tempChargeOptions, setTempChargeOptions] = useState([]);
  const [paymentTypeOptions, setPaymentTypeOptions] = useState([]);
  const [isChargeModalOpen, setIsChargeModalOpen] = useState(false);
  const [chargeTableSource, setChargeTableSource] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [incomeAccountOptions, setIncomeAccountOptions] = useState([]);
  const [feesOptions, setFeesOptions] = useState([]);
  const [penaltyOptions, setPenaltyOptions] = useState([]);
  const [fixedDepositDetails, setFixedDepositDetails] = useState([]);
  const [initialValues, setInitialValues] = useState({});
  const [assetAccountOptions, setAssetAccountOptions] = useState([]);
  const [fundCount, setFundCount] = useState(1);
  const [feeCount, setFeeCount] = useState(1);
  const [penaltyCount, setPenaltyCount] = useState(1);
  const [useForm] = Form.useForm();
  const [taxGroupId, setTaxGroupId] = useState();
  const isWithHoldingTax = Form.useWatch("withHoldTax", useForm);
  const [isPrimaryGroupingByAmnt, setIsPrimaryGroupingByAmnt] = useState(false);
  const [currency, setCurrency] = useState(null);
  const preClosurePenalApplicable = Form.useWatch(
    "preClosurePenalApplicable",
    useForm,
  );

  useEffect(() => {
    getDetailById(state);
    console.log(isLoading);
  }, []);

  function onCancel() {
    navigate("/prd0500", { replace: false });
  }

  const getDetailById = (params) => {
    const url = `${definedApi.EditFixedDeposit}/${params.key}?template=true`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        // setIsLoading(false);
        const objDetail = res;
        setFixedDepositDetails(objDetail);

        let tempCurrency = [];
        let tempInterestCompoundingPeriodTypeOptions = [];
        let tempInterestPostingPeriodTypeOptions = [];
        let tempInterestCalculationTypeOptions = [];
        let tempInterestCalculationDaysInYearTypeOptions = [];
        let tempLockinPeriodFrequencyTypeOptions = [];
        let tempPeriodFrequencyTypeOptions = [];
        let tempMinDepositTypeOptions = [];
        let tempMaxDepositTypeOptions = [];
        let tempInMultiplesOfDepositTermTypeOptions = [];
        let tempPreClosurePenalInterestOnTypeOptions = [];
        let tempTaxGroupOptions = [];
        let tempPeriodTypeOptions = [];
        let tempAssetAccountOptions = [];
        let tempPaymentTypeOptions = [];
        let tempFeesOptions = [];
        let tempPenaltyOptions = [];
        let tempAccountingRuleOptions = [];
        let tempAttributeNameOptions = [];
        let tempConditionTypeOptions = [];
        let tempChargesOptions = [];
        let tempCharges = [];
        let tempIncomeAccountOptions = [];
        let tempExpenseAccountOptions = [];
        let tempLiabilityAccountOptions = [];
        let tempInterestRateTableSource = [];
        let tempChargesTableSource = [];
        let tempPreClosurePenalInterestStrategyOptions = [];

        // SHOW THE SAVED DATA
        useForm.setFieldsValue({
          name: objDetail?.name ? objDetail?.name : null,
          shortName: objDetail?.shortName ? objDetail?.shortName : null,
          description: objDetail?.description ? objDetail?.description : null,
          currencyCode: objDetail?.currency?.code
            ? objDetail?.currency?.code
            : null,
          inMultiplesOf: objDetail?.currency?.inMultiplesOf
            ? objDetail?.currency?.inMultiplesOf
            : null,
          digitsAfterDecimal: objDetail?.currency?.decimalPlaces
            ? objDetail?.currency?.decimalPlaces
            : null,
          depositAmount: objDetail?.depositAmount
            ? objDetail?.depositAmount
            : null,
          isUpfrontFeesCollection: objDetail?.isUpfrontFeesCollection,
          minDepositAmount: objDetail?.minDepositAmount
            ? objDetail?.minDepositAmount
            : null,
          maxDepositAmount: objDetail?.maxDepositAmount
            ? objDetail?.maxDepositAmount
            : null,
          interestCompoundingPeriodType: objDetail
            ?.interestCompoundingPeriodType?.id
            ? objDetail?.interestCompoundingPeriodType?.id
            : null,
          interestCalculationType: objDetail?.interestCalculationType?.id
            ? objDetail?.interestCalculationType?.id
            : null,
          interestCalculationDaysInYearType: objDetail
            ?.interestCalculationDaysInYearType?.id
            ? objDetail?.interestCalculationDaysInYearType?.id
            : null,
          lockinPeriodFrequency: objDetail?.lockinPeriodFrequency
            ? objDetail?.lockinPeriodFrequency
            : null,
          interestPostingPeriodType:
            objDetail?.interestPostingPeriodType?.value,
          withHoldTax: objDetail?.withHoldTax,
          preClosurePenalApplicable: objDetail?.preClosurePenalApplicable,
          lockinPeriodFrequencyType: objDetail?.lockinPeriodFrequencyType?.id,
          preClosurePenalInterestOnTypeId:
            objDetail?.preClosurePenalInterestOnType?.id,
          preClosurePenalInterest: objDetail?.preClosurePenalInterest
            ? objDetail?.preClosurePenalInterest
            : null,
          inMultiplesOfDepositTerm: objDetail?.inMultiplesOfDepositTerm
            ? objDetail?.inMultiplesOfDepositTerm
            : null,
          inMultiplesOfDepositTermTypeId: objDetail
            ?.inMultiplesOfDepositTermType?.id
            ? objDetail?.inMultiplesOfDepositTermType?.id
            : 0,

          minDepositTerm: objDetail?.minDepositTerm
            ? objDetail?.minDepositTerm
            : null,
          preClosurePenalInterestStrategyId:
            objDetail?.preClosurePenalInterestStrategy
              ? objDetail?.preClosurePenalInterestStrategy?.id
              : null,
          minDepositTermTypeId: objDetail?.minDepositTermType?.id,
          maxDepositTerm: objDetail?.maxDepositTerm
            ? objDetail?.maxDepositTerm
            : null,
          maxDepositTermTypeId: objDetail?.maxDepositTermType?.id,
          taxGroupId: objDetail?.taxGroup?.id,
          fromDate: objDetail?.activeChart?.fromDate
            ? dayjs(BOM.FormatArrayDate(objDetail?.activeChart?.fromDate))
            : objDetail?.activeChart?.fromDate,
          endDate: objDetail?.activeChart?.endDate
            ? dayjs(BOM.FormatArrayDate(objDetail?.activeChart?.endDate))
            : objDetail?.activeChart?.endDate,
          periodType: objDetail?.interestRateCharts[0]?.chartSlabs[0]
            ?.periodType?.value
            ? objDetail?.interestRateCharts[0]?.chartSlabs[0]?.periodType?.value
            : null,
          fromPeriod: objDetail?.interestRateCharts[0]?.chartSlabs[0]
            ?.fromPeriod
            ? objDetail?.interestRateCharts[0]?.chartSlabs[0]?.fromPeriod
            : null,
          annualInterestRate: objDetail?.interestRateCharts[0]?.chartSlabs[0]
            ?.annualInterestRate
            ? objDetail?.interestRateCharts[0]?.chartSlabs[0]
                ?.annualInterestRate
            : null,
          savingsReferenceAccountId: objDetail?.accountingMappings
            ? objDetail?.accountingMappings?.savingsReferenceAccount?.id
            : null,
          isPrimaryGroupingByAmount:
            objDetail?.activeChart?.isPrimaryGroupingByAmount,
          enableManualInterestEntry: objDetail?.activeChart
            ?.enableManualInterestEntry
            ? objDetail?.activeChart?.enableManualInterestEntry
            : null,
          minimumManualInterestAmount: objDetail?.activeChart
            ?.minimumManualInterestAmount
            ? objDetail?.activeChart?.minimumManualInterestAmount
            : null,
          maximumManualInterestAmount: objDetail?.activeChart
            ?.maximumManualInterestAmount
            ? objDetail?.activeChart?.maximumManualInterestAmount
            : null,
          savingsControlAccountId: objDetail?.accountingMappings
            ? objDetail?.accountingMappings?.savingsControlAccount?.id
            : null,

          transfersInSuspenseAccountId: objDetail?.accountingMappings
            ? objDetail?.accountingMappings?.transfersInSuspenseAccount?.id
            : null,
          interestOnSavingsAccountId: objDetail?.accountingMappings
            ? objDetail?.accountingMappings?.interestOnSavingsAccount?.id
            : null,
          incomeFromFeeAccountId: objDetail?.accountingMappings
            ? objDetail?.accountingMappings?.incomeFromFeeAccount?.id
            : null,
          incomeFromPenaltyAccountId: objDetail?.accountingMappings
            ? objDetail?.accountingMappings?.incomeFromPenaltyAccount?.id
            : null,
        });

        objDetail?.preClosurePenalInterestStrategyOptions
          ?.filter((element) => element.id == 2)
          .forEach((element) => {
            tempPreClosurePenalInterestStrategyOptions.push({
              value: element.id,
              label: element.value,
            });
          });
        objDetail?.chargeOptions?.forEach((element) => {
          tempFeesOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.accountingMappingOptions?.assetAccountOptions?.forEach(
          (element) => {
            tempAssetAccountOptions.push({
              value: element.id,
              label: `${element.glCode} (${element.name})`,
              currency: element.currencyCode,
            });
          },
        );

        objDetail?.accountingMappingOptions?.incomeAccountOptions?.forEach(
          (element) => {
            tempIncomeAccountOptions.push({
              value: element.id,
              label: `${element.glCode} (${element.name})`,
              currency: element.currencyCode,
            });
          },
        );

        objDetail?.accountingMappingOptions?.expenseAccountOptions?.forEach(
          (element) => {
            tempExpenseAccountOptions.push({
              value: element.id,
              label: `${element.glCode} (${element.name})`,
              currency: element.currencyCode,
            });
          },
        );

        objDetail?.accountingMappingOptions?.liabilityAccountOptions?.forEach(
          (element) => {
            tempLiabilityAccountOptions.push({
              value: element.id,
              label: `${element.glCode} (${element.name})`,
              currency: element.currencyCode,
            });
          },
        );

        objDetail?.currencyOptions?.forEach((element) => {
          tempCurrency.push({
            value: element?.code,
            label: element?.displayLabel,
          });
        });

        objDetail?.interestCompoundingPeriodTypeOptions?.forEach((element) => {
          tempInterestCompoundingPeriodTypeOptions.push({
            value: element?.id,
            label: element?.value,
          });
        });

        objDetail?.interestPostingPeriodTypeOptions?.forEach((element) => {
          tempInterestPostingPeriodTypeOptions.push({
            value: element?.id,
            label: element?.value,
          });
        });

        objDetail?.interestCalculationTypeOptions?.forEach((element) => {
          tempInterestCalculationTypeOptions.push({
            value: element?.id,
            label: element?.value,
          });
        });

        objDetail?.interestCalculationDaysInYearTypeOptions?.forEach(
          (element) => {
            tempInterestCalculationDaysInYearTypeOptions.push({
              value: element?.id,
              label: element?.value,
            });
          },
        );

        objDetail?.lockinPeriodFrequencyTypeOptions?.forEach((element) => {
          tempLockinPeriodFrequencyTypeOptions.push({
            value: element?.id,
            label: element?.value,
          });
        });

        objDetail?.periodFrequencyTypeOptions?.forEach((element) => {
          tempMinDepositTypeOptions.push({
            value: element?.id,
            label: element?.value,
          });
        });

        objDetail?.periodFrequencyTypeOptions?.forEach((element) => {
          tempMaxDepositTypeOptions.push({
            value: element?.id,
            label: element?.value,
          });
        });

        objDetail?.periodFrequencyTypeOptions?.forEach((element) => {
          tempInMultiplesOfDepositTermTypeOptions.push({
            value: element?.id,
            label: element?.value,
          });
        });

        objDetail?.preClosurePenalInterestOnTypeOptions?.forEach((element) => {
          tempPreClosurePenalInterestOnTypeOptions.push({
            value: element?.id,
            label: element?.value,
          });
        });

        objDetail?.taxGroupOptions?.forEach((element) => {
          tempTaxGroupOptions.push({
            value: element?.id,
            label: element?.name,
          });
        });

        objDetail?.periodFrequencyTypeOptions?.forEach((element) => {
          tempPeriodTypeOptions.push({
            value: element?.id,
            label: element?.value,
          });
        });

        objDetail?.periodFrequencyTypeOptions?.forEach((element) => {
          tempPeriodFrequencyTypeOptions.push({
            value: element?.id,
            label: element?.value,
          });
        });

        objDetail?.paymentTypeOptions?.forEach((element) => {
          tempPaymentTypeOptions.push({
            value: element?.id,
            label: element?.name,
          });
        });

        objDetail?.penaltyOptions?.forEach((element) => {
          tempPenaltyOptions.push({
            value: element?.id,
            label: element?.name,
          });
        });

        objDetail?.accountingRuleOptions?.forEach((element) => {
          tempAccountingRuleOptions.push({
            value: element?.id,
            label: element?.value,
          });
        });

        objDetail?.chartTemplate?.attributeNameOptions?.forEach((element) => {
          tempAttributeNameOptions.push({
            value: element?.id,
            label: element?.value,
          });
        });

        objDetail?.chartTemplate?.conditionTypeOptions?.forEach((element) => {
          tempConditionTypeOptions.push({
            value: element?.id,
            label: element?.value,
          });
        });

        objDetail?.activeChart?.chartSlabs?.forEach((element) => {
          tempInterestRateTableSource.push({
            key: element?.id,
            id: element?.id,
            periodType: element?.periodType?.value,
            fromPeriod: element?.fromPeriod,
            toPeriod: element?.toPeriod,
            amountRangeFrom: element?.amountRangeFrom
              ? Number(element?.amountRangeFrom).toLocaleString()
              : "-",
            amountRangeTo: element?.amountRangeTo
              ? Number(element?.amountRangeTo).toLocaleString()
              : "-",
            annualInterestRate: element?.annualInterestRate,
            description: element?.description,
          });
        });

        objDetail?.charges?.forEach((element) => {
          tempChargesTableSource.push({
            key: element?.id,
            id: element?.id,
            name: element?.name,
            type: element?.chargeCalculationType?.value,
            collectedOn: element?.chargeTimeType?.value,
            amountToUse: element?.amount,
            amount: (
              <Statistic
                value={element?.amount}
                precision={2}
                valueStyle={{ fontSize: "16px" }}
              />
            ),
          });
        });

        const initialCurrency = objDetail?.currency?.code;

        objDetail?.chargeOptions?.forEach((element) => {
          tempChargesOptions.push({
            value: element.id,
            label: `${element.name}(${element?.currency?.name})`,
            currencyName: element?.currency?.name,
            currencyCode: element?.currency?.code,
          });
        });

        const chargeForTableData = tempChargesOptions.filter(
          (item) => item.currencyCode === initialCurrency,
        );

        setChargesOptions([...chargeForTableData]);
        setChargeTableSource(tempCharges);

        setCurrency(initialCurrency);

        setCurrencyData(tempCurrency);
        // setCurrency(objDetail?.currency?.code);
        setInterestCompoundingPeriodTypeOptions(
          tempInterestCompoundingPeriodTypeOptions,
        );
        setInterestPostingPeriodTypeOptions(
          tempInterestPostingPeriodTypeOptions,
        );
        setInterestCalculationTypeOptions(tempInterestCalculationTypeOptions);
        setInterestCalculationDaysInYearTypeOptions(
          tempInterestCalculationDaysInYearTypeOptions,
        );
        setLockinPeriodFrequencyTypeOptions(
          tempLockinPeriodFrequencyTypeOptions,
        );
        setPeriodFrequencyTypeOptions(tempPeriodFrequencyTypeOptions);
        setMinDepositTypeOptions(tempMinDepositTypeOptions);
        setMaxDepositTypeOptions(tempMaxDepositTypeOptions);
        setInMultiplesOfDepositTermTypeOptions(
          tempInMultiplesOfDepositTermTypeOptions,
        );
        setPreClosurePenalInterestOnTypeOptions(
          tempPreClosurePenalInterestOnTypeOptions,
        );
        setTaxGroupOptions(tempTaxGroupOptions);
        setPeriodTypeOptions(tempPeriodTypeOptions);
        setPaymentTypeOptions(tempPaymentTypeOptions);
        setFeesOptions(tempFeesOptions);
        setIncomeAccountOptions(tempIncomeAccountOptions);
        setTempChargeOptions(objDetail?.chargeOptions);
        setPenaltyOptions(tempPenaltyOptions);
        setAssetAccountOptions(tempAssetAccountOptions);
        setLiabilityAccountOptions(tempLiabilityAccountOptions);
        setExpenseAccountOptions(tempExpenseAccountOptions);
        setInterestRateTableSource(tempInterestRateTableSource);
        setChargeTableSource(tempChargesTableSource);
        setForPrematureClosure(objDetail?.preClosurePenalApplicable);
        setPreClosurePenalInterestStrategyOptions(
          tempPreClosurePenalInterestStrategyOptions,
        );

        setIsLoading(false);

        setInitialValues(
          useForm.getFieldsValue([
            "name",
            "shortName",
            "description",
            "currencyCode",
            "inMultiplesOf",
            "digitsAfterDecimal",
            "depositAmount",
            "minDepositAmount",
            "maxDepositAmount",
            "interestCompoundingPeriodType",
            "interestCompoundingPeriodType",
            "interestCalculationType",
            "inMultiplesOfDepositTerm",
            "inMultiplesOfDepositTermTypeId",
            "minDepositTerm",
            "minDepositTermTypeId",
            "maxDepositTerm",
            "maxDepositTermTypeId",
            "savingsReferenceAccountId",
          ]),
        );
      }
    });
  };

  const chargeTableColumns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },
    {
      title: "Collected On",
      dataIndex: "collectedOn",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        chargeTableSource.length >= 1 ? (
          <Tooltip title={`Remove Charge`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleChargeDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  const handleChargeDelete = (key) => {
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.name, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = chargeTableSource.filter((item) => item.id !== key.id);
        setChargeTableSource(newData);
      },

      function () {
        // No button
      },
    );
  };

  const onChangeCurrency = (value) => {
    const selectedCurrency = value;
    let tempChargesOptions = [];
    let tempCharges = [];
    setCurrency(selectedCurrency);
    fixedDepositDetails?.chargeOptions?.forEach((element) => {
      tempChargesOptions.push({
        value: element.id,
        label: `${element.name}(${element?.currency?.name})`,
        currencyName: element?.currency?.name,
        currencyCode: element?.currency?.code,
      });

      const chargeForTableData = tempChargesOptions.filter(
        (item) => item.currencyCode === selectedCurrency,
      );
      setChargeTableSource(tempCharges);
      setChargesOptions([...chargeForTableData]);
    });

    useForm.setFieldsValue({
      // Reset all accounting-related fields
      savingsReferenceAccountId: undefined,
      savingsControlAccountId: undefined,
      transfersInSuspenseAccountId: undefined,
      interestOnSavingsAccountId: undefined,
      incomeFromFeeAccountId: undefined,
      incomeFromPenaltyAccountId: undefined,
      // Reset advanced accounting fields if they exist
      configureFundOptions: undefined,
      fundSourceAccountId: undefined,
      chargeId: undefined,
      incomeAccountId: undefined,
      penaltySpecificIncomeaccounts: undefined,
      penaltySpecificIncomeaccount: undefined,
    });
  };

  const filteredAssetAccounts = assetAccountOptions.filter(
    (item) => item.currency === currency,
  );

  const filteredIncomeAccounts = incomeAccountOptions.filter(
    (item) => item.currency === currency,
  );
  const filteredexpenseAccountOptions = expenseAccountOptions.filter(
    (item) => item.currency === currency,
  );
  const filteredLiabilityAccountOptions = liabilityAccountOptions.filter(
    (item) => item.currency === currency,
  );

  const handleInterestPostingPeriodTypeChange = (value) => {
    setInterestPostingPeriodType(value);
  };
  const handleTaxGroupIdChange = (value) => {
    setTaxGroupId(value);
  };
  const handleForPremClosure = (value) => {
    setForPrematureClosure(value);
  };
  const onSubmit = (formValues) => {
    let tempChargeArray = [];
    let tempPaymentChannelToFundSourceMappingsArray = [];
    let tempFeeToIncomeAccountMappingsArray = [];
    let tempPenaltyToIncomeAccountMappingsArray = [];

    delete formValues.interestPostingPeriodType;

    formValues.interestPostingPeriodType = interestPostingPeriodType;
    formValues.preClosurePenalInterestOnTypeId = 2;

    chargeTableSource.forEach((element) => {
      tempChargeArray.push({
        id: element.id,
      });
    });

    configureFundTableSource.forEach((element, index) => {
      tempPaymentChannelToFundSourceMappingsArray.push({
        paymentTypeId: element.paymentTypeId,
        fundSourceAccountId: element.fundSourceAccountId,
      });
    });

    mapFeeTableSource.forEach((element, index) => {
      tempFeeToIncomeAccountMappingsArray.push({
        chargeId: element.chargeId,
        incomeAccountId: element.incomeAccountId,
      });
    });

    mapPenaltyTableSource.forEach((element, index) => {
      tempPenaltyToIncomeAccountMappingsArray.push({
        paymentTypeId: element.paymentTypeId,
        fundSourceAccountId: element.fundSourceAccountId,
      });
    });

    formValues.accountingRule = "2";
    formValues.nominalAnnualInterestRate = 0;
    formValues.charges = tempChargeArray;
    formValues.paymentChannelToFundSourceMappings =
      tempPaymentChannelToFundSourceMappingsArray;
    formValues.feeToIncomeAccountMappings = tempFeeToIncomeAccountMappingsArray;
    formValues.penaltyToIncomeAccountMappings =
      tempPenaltyToIncomeAccountMappingsArray;
    const cleanValue = (val) => {
      if (val === null || val === undefined || val === "") return undefined;
      const stripped = typeof val === "string" ? val.replace(/,/g, "") : val;
      return String(stripped);
    };
    const chartSlabs = interestRateTableSource.map((element) => {
      const slab = {
        description: element.description,
        periodType: fixedDepositDetails?.periodFrequencyTypeOptions.find(
          (item) => item.value === element.periodType,
        )?.id,
        locale: "en",
        incentives: [],
        id: element.id,
      };

      console.log(slab);

      // Add only if value exists
      const optionalFields = {
        amountRangeFrom: cleanValue(element.amountRangeFrom),
        amountRangeTo:
          element.amountRangeTo === "-" || element.amountRangeTo === ""
            ? null
            : cleanValue(element.amountRangeTo),
        fromPeriod: cleanValue(element.fromPeriod),
        toPeriod: cleanValue(element.toPeriod),
        annualInterestRate: cleanValue(element.annualInterestRate),
      };

      Object.entries(optionalFields).forEach(([key, value]) => {
        if (value !== undefined) {
          slab[key] = value;
        }
      });

      return slab;
    });

    formValues.charts = [
      {
        id: fixedDepositDetails?.activeChart?.id,
        fromDate: formValues.fromDate
          ? BOM.DateTime(formValues.fromDate, "only-date")
          : null,
        endDate: formValues.endDate
          ? BOM.DateTime(formValues.endDate, "only-date")
          : null,
        dateFormat: "dd MMMM yyyy",
        locale: "en",
        isPrimaryGroupingByAmount: formValues.isPrimaryGroupingByAmount,
        enableManualInterestEntry: formValues.enableManualInterestEntry,
        minimumManualInterestAmount: formValues.minimumManualInterestAmount,
        maximumManualInterestAmount: formValues.maximumManualInterestAmount,
        chartSlabs: interestRateTableSource.length > 0 ? [...chartSlabs] : [],
      },
    ];

    delete formValues.fromDate;
    delete formValues.endDate;
    delete formValues.isPrimaryGroupingByAmount;
    delete formValues.enableManualInterestEntry;
    delete formValues.minimumManualInterestAmount;
    delete formValues.maximumManualInterestAmount;

    const url = `${definedApi.EditFixedDeposit}/${state.key}`;

    const body = {
      ...formValues,
      locale: "en",
      method: "PUT",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, appLabel.editCallDepositMsg);
          navigate("/prd0500");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/prd0500");
          setIsLoading(false);
        },
      },
    );
  };

  console.log(isLoading);

  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent
        pageTitle={appLabel.editCallDeposit}
        pageItems={appStatic.editCallDepositItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            layout="vertical"
            style={{ margin: 30 }}
            onFinish={onSubmit}
            form={useForm}
            onValuesChange={(changedValues, allValues) =>
              setInitialValues({ ...initialValues, ...changedValues })
            }
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {"Call Deposit Product Setup"}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.details}
                </Title>
              </Divider>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Product Name</Text>}
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input placeholder="Product Name"></Input>
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Short Name</Text>}
                  name="shortName"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input maxLength={4} placeholder="Short Name" />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={<Text>Description</Text>} name="description">
                  <Input.TextArea></Input.TextArea>
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Currency</Text>}
                  name="currencyCode"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase(),
                      )
                    }
                    showSearch
                    options={currencyData}
                    onChange={onChangeCurrency}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Decimal Places</Text>}
                  name={"digitsAfterDecimal"}
                  // initialValue={currencyData[0]?.decimalPlaces}
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Multiples Of</Text>}
                  name={"inMultiplesOf"}
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>

              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.interestInformation}
                </Title>
              </Divider>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Default Deposit Amount</Text>}
                  name={"depositAmount"}
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                    placeholder="Not set"
                    className="of-bold-disable-input"
                    value={fixedDepositDetails.depositAmount ?? null}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Minimum Deposit Amount</Text>}
                  name={"minDepositAmount"}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                    placeholder="Not set"
                    className="of-bold-disable-input"
                    value={fixedDepositDetails.minDepositAmount ?? null}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Maximum Deposit Amount</Text>}
                  name={"maxDepositAmount"}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                    placeholder="Not set"
                    className="of-bold-disable-input"
                    value={fixedDepositDetails.maxDepositAmount ?? null}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Interest Compounding Period</Text>}
                  name="interestCompoundingPeriodType"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Select
                    className="of-bold-disable-input"
                    placeholder={
                      fixedDepositDetails?.interestCompoundingPeriodType?.value
                    }
                    options={interestCompoundingPeriodTypeOptions}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Interest Posting Period</Text>}
                  name="interestPostingPeriodType"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Select
                    className="of-bold-disable-input"
                    options={interestPostingPeriodTypeOptions}
                    onChange={handleInterestPostingPeriodTypeChange}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Interest Calculated Using</Text>}
                  name="interestCalculationType"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Select
                    className="of-bold-disable-input"
                    placeholder={
                      fixedDepositDetails?.interestCalculationType?.value
                    }
                    options={interestCalculationTypeOptions}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Days In Year</Text>}
                  name="interestCalculationDaysInYearType"
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Select
                    options={interestCalculationDaysInYearTypeOptions}
                    className="of-bold-disable-input"
                    placeholder={
                      fixedDepositDetails?.interestCalculationDaysInYearType
                        ?.value
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  name={"isUpfrontFeesCollection"}
                  label={<Text strong>Collect interest upfront</Text>}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase(),
                      )
                    }
                    showSearch
                    allowClear
                    placeholder="Select Option"
                    options={staticConfig.yesOrNo}
                    // onChange={handleDormancyTracking}
                  />
                </Form.Item>
              </Col>

              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {"Settings"}
                </Title>
              </Divider>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Lock-in Period</Text>}
                  name="lockinPeriodFrequency"
                >
                  <Input className="of-bold-disable-input" />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Lock-in Period Frequency Type</Text>}
                  name="lockinPeriodFrequencyType"
                >
                  <Select
                    className="of-bold-disable-input"
                    options={lockinPeriodFrequencyTypeOptions}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Minimum Deposit Term</Text>}
                  name={"minDepositTerm"}
                >
                  <Input className="of-bold-disable-input" />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Minimum Deposit Term Type</Text>}
                  name={"minDepositTermTypeId"}
                >
                  <Select
                    className="of-bold-disable-input"
                    options={minDepositTypeOptions}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>And Thereafter, In Multiples Of </Text>}
                  name={"inMultiplesOfDepositTerm"}
                >
                  <Input
                    className="of-bold-disable-input"
                    placeholder={fixedDepositDetails?.inMultiplesOfDepositTerm}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>And Thereafter, In Multiples Of Types</Text>}
                  name={"inMultiplesOfDepositTermTypeId"}
                >
                  <Select
                    className="of-bold-disable-input"
                    options={minDepositTypeOptions}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Maximum Deposit Term </Text>}
                  name={"maxDepositTerm"}
                >
                  <Input className="of-bold-disable-input" />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>Maximum Deposit Term Type</Text>}
                  name={"maxDepositTermTypeId"}
                >
                  <Select
                    className="of-bold-disable-input"
                    placeholder={fixedDepositDetails?.maxDepositTermType?.value}
                    options={minDepositTypeOptions}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  name={"preClosurePenalApplicable"}
                  label={
                    <Text>Apply Penal Interest for Pre-mature Closure?</Text>
                  }
                >
                  <Select
                    className="of-bold-disable-input"
                    options={staticConfig.yesOrNo}
                    onChange={handleForPremClosure}
                  />
                </Form.Item>
              </Col>

              {/* <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={<Text>On </Text>}
                      name={"preClosurePenalInterestOnTypeId"}
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                      }
                    >
                      <Select
                        className="of-bold-disable-input"
                        options={preClosurePenalInterestOnTypeOptions}
                        showSearch
                      />
                    </Form.Item>
                  </Col> */}
              {preClosurePenalApplicable && (
                <>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={<Text>Apply Penal Interest (less) </Text>}
                      name={"preClosurePenalInterest"}
                      rules={[
                        {
                          required: preClosurePenalApplicable,
                          message: "Required Field",
                        },
                      ]}
                    >
                      <Input className="of-bold-disable-input" />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={<Text>Penalty Calculation Method </Text>}
                      name={"preClosurePenalInterestStrategyId"}
                      rules={[
                        {
                          required: preClosurePenalApplicable,
                          message: "Required Field",
                        },
                      ]}
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase(),
                        )
                      }
                    >
                      <Select
                        className="of-bold-disable-input"
                        options={preClosurePenalInterestStrategyOptions}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                </>
              )}
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  name="withHoldTax"
                  label={<Text>Is Withhold Tax Applicable</Text>}
                >
                  <Select
                    className="of-bold-disable-input"
                    options={staticConfig.yesOrNo}
                  />
                </Form.Item>
              </Col>
              {isWithHoldingTax && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text strong>Tax Group</Text>}
                    name="taxGroupId"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld("Tax Group"),
                      },
                    ]}
                  >
                    <Select
                      onChange={handleTaxGroupIdChange}
                      options={taxGroupOptions}
                      placeholder={"Please select a value"}
                    />
                  </Form.Item>
                </Col>
              )}
            </Row>
            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.interestRateInfo}
              </Title>
            </Divider>
            <InterestRateChart
              interestRateTableSource={interestRateTableSource}
              setInterestRateTableSource={setInterestRateTableSource}
              userData={userData}
              isPrimaryGroupingByAmnt={isPrimaryGroupingByAmnt}
              setIsPrimaryGroupingByAmnt={setIsPrimaryGroupingByAmnt}
              periodTypeOptions={periodTypeOptions}
              form={useForm}
            />
            ,
            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.chargeInfo}
              </Title>
            </Divider>
            <ChargeModal
              // formData={formData}
              isChargeModalOpen={isChargeModalOpen}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              setIsChargeModalOpen={setIsChargeModalOpen}
              chargeData={chargesOptions}
              setChargeList={setChargeList}
              setChargeTableSource={setChargeTableSource}
              chargeTableSource={chargeTableSource}
              chargeList={chargeList}
              session={session}
            />
            {chargeTableSource?.length > 0 && (
              <>
                <Divider orientation="left" orientationMargin="0">
                  <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {chargeTableSource.length > 1
                      ? labelConfig.selectedCharges
                      : labelConfig.selectedCharge}
                  </Title>
                </Divider>
                <Table
                  columns={chargeTableColumns}
                  dataSource={chargeTableSource}
                  bordered
                  pagination={{
                    position: "bottomCentre",
                    pageSize: "10",
                  }}
                />
              </>
            )}
            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {"Accounting Information"}
              </Title>
            </Divider>
            <div>
              <div>
                <Title level={4}>Assets</Title>
                <Divider style={{ margin: 0, padding: 0 }} />
                <Row>
                  <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      name="savingsReferenceAccountId"
                      label={<Text strong> Deposit Reference</Text>}
                      rules={[
                        {
                          required: true,
                          message: "Required Field",
                        },
                      ]}
                    >
                      <Select
                        filterOption={(input, option) =>
                          (option?.label?.toLowerCase() ?? "").includes(
                            input?.toLowerCase(),
                          )
                        }
                        options={filteredAssetAccounts}
                        placeholder={"Select an Option"}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Title level={4}>Liabilities</Title>
                <Divider style={{ margin: 0, padding: 0 }} />
                <Row>
                  <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      name="savingsControlAccountId"
                      label={<Text strong>Deposit Control</Text>}
                    >
                      <Select
                        filterOption={(input, option) =>
                          (option?.label?.toLowerCase() ?? "").includes(
                            input?.toLowerCase(),
                          )
                        }
                        options={filteredLiabilityAccountOptions}
                        placeholder={"Select an Option"}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="transfersInSuspenseAccountId"
                      label={<Text strong> Transfers In Suspense</Text>}
                      rules={[
                        {
                          required: true,
                          message: "Required Field",
                        },
                      ]}
                    >
                      <Select
                        filterOption={(input, option) =>
                          (option?.label?.toLowerCase() ?? "").includes(
                            input?.toLowerCase(),
                          )
                        }
                        options={filteredLiabilityAccountOptions}
                        placeholder={"Select an Option"}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
              <div>
                <Title level={4}>Expenses</Title>
                <Divider style={{ margin: 0, padding: 0 }} />
                <Row>
                  <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      name="interestOnSavingsAccountId"
                      label={<Text>Interest On Deposits</Text>}
                      rules={[
                        {
                          required: true,
                          message: "Required Field",
                        },
                      ]}
                    >
                      <Select
                        filterOption={(input, option) =>
                          (option?.label?.toLowerCase() ?? "").includes(
                            input?.toLowerCase(),
                          )
                        }
                        options={filteredexpenseAccountOptions}
                        placeholder={"Select an Option"}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
              <div>
                <Title level={4}>Income</Title>
                <Divider style={{ margin: 0, padding: 0 }} />
                <Row>
                  <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      name="incomeFromFeeAccountId"
                      label={<Text>Income From Fees</Text>}
                      rules={[
                        {
                          required: true,
                          message: "Required Field",
                        },
                      ]}
                    >
                      <Select
                        filterOption={(input, option) =>
                          (option?.label?.toLowerCase() ?? "").includes(
                            input?.toLowerCase(),
                          )
                        }
                        options={filteredIncomeAccounts}
                        placeholder={"Select an Option"}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      name="incomeFromPenaltyAccountId"
                      label={<Text>Income From Penalties</Text>}
                      rules={[
                        {
                          required: true,
                          message: "Required Field",
                        },
                      ]}
                    >
                      <Select
                        filterOption={(input, option) =>
                          (option?.label?.toLowerCase() ?? "").includes(
                            input?.toLowerCase(),
                          )
                        }
                        options={filteredIncomeAccounts}
                        placeholder={"Select an Option"}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
              <Title level={4}>
                Advanced Accounting Rule:{" "}
                <span>
                  {showAdvancedAccounting ? (
                    <>
                      <Button
                        type="dashed"
                        onClick={() =>
                          setShowAdvancedAccounting(!showAdvancedAccounting)
                        }
                        icon={<DownOutlined />}
                      >
                        Hide
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        type="dashed"
                        onClick={() =>
                          setShowAdvancedAccounting(!showAdvancedAccounting)
                        }
                        icon={<RightOutlined />}
                      >
                        Show
                      </Button>
                    </>
                  )}
                </span>
              </Title>
              <Divider style={{ margin: 0, padding: 0 }} />
              {showAdvancedAccounting && (
                <>
                  <ConfigureFundSource
                    // onFinish={onFinish}
                    // form={useForm}
                    userData={userData}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    paymentTypeOptions={paymentTypeOptions}
                    assetAccountOptions={filteredAssetAccounts}
                    configureFundTableSource={configureFundTableSource}
                    setConfigureFundTableSource={setConfigureFundTableSource}
                    fundCount={fundCount}
                    setFundCount={setFundCount}
                  />
                  <MapFees
                    // onFinish={onFinish}
                    // form={useForm}
                    userData={userData}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    feesOptions={feesOptions}
                    incomeAccountOptions={filteredIncomeAccounts}
                    mapFeeTableSource={mapFeeTableSource}
                    setMapFeeTableSource={setMapFeeTableSource}
                    feeCount={feeCount}
                    setFeeCount={setFeeCount}
                  />

                  <MapPenalties
                    // onFinish={onFinish}
                    // form={useForm}
                    userData={userData}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    penaltyOptions={penaltyOptions}
                    incomeAccountOptions={filteredIncomeAccounts}
                    mapPenaltyTableSource={mapPenaltyTableSource}
                    setMapPenaltyTableSource={setMapPenaltyTableSource}
                    penaltyCount={penaltyCount}
                    setPenaltyCount={setPenaltyCount}
                  />
                </>
              )}
            </div>
            <Row>
              <Divider />
              {BOM.HasPermission("UPDATE_FIXEDDEPOSITPRODUCT") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
              )}
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EditPRD0500);

const ChargeModal = (props) => {
  const {
    session,
    isLoading,
    setIsLoading,
    setChargeTableSource,
    chargeTableSource,
    isChargeModalOpen,
    chargeData,
    setIsChargeModalOpen,
    setChargeList,
    chargeList,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsChargeModalOpen(true);
  };
  const handleOk = () => {
    setIsChargeModalOpen(false);
  };
  const handleCancel = () => {
    setIsChargeModalOpen(false);
  };

  const handleChargeSave = (formValues) => {
    const newCharges = {
      key: formValues?.chargeId,
      id: formValues?.chargeId,
      name: formValues.name,
      type: formValues.type,
      collectedOn: formValues.collectedOn,
      amountToUse: formValues?.amount,
      amount: (
        <Statistic
          value={formValues?.amount}
          precision={2}
          valueStyle={{ fontSize: "16px" }}
        />
      ),
    };

    let foundCharge = chargeTableSource.find(
      (item) => item.id === newCharges?.id,
    );
    if (foundCharge) {
      BOM.AlertMsg(cnt.WARNING, "No duplicate Charge allowed!");
      return;
    }
    setChargeTableSource([...chargeTableSource, newCharges]);

    useForm.resetFields();
  };

  const handleSelectedCharge = (chargeId) => {
    const params = {
      template: "true",
    };

    const url = `${apiConfig.charges}/${chargeId}`;

    const body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;

        useForm.setFieldsValue({
          key: objList?.id,
          id: objList?.id,
          name: objList?.name,
          type: objList?.chargeCalculationType?.value,
          collectedOn: objList?.chargeTimeType?.value,
          amount: objList?.amount,
        });

        // STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <Row>
      <Button
        type="primary"
        onClick={showModal}
        icon={<PlusOutlined />}
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#92428B",
          marginBottom: 20,
        }}
      >
        {labelConfig.addCharge}
      </Button>

      <Modal
        title="Charge Information Setup"
        open={isChargeModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleChargeSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="chargeId"
                label="Charge Options"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.charge),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase(),
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.charge,
                    "select",
                  )}
                  options={chargeData}
                  onChange={handleSelectedCharge}
                  style={{ width: "30vh" }}
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Divider />
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.name} name={"name"}>
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.name)}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.type} name={"type"}>
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.type)}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.collectedOn} name={"collectedOn"}>
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.collectedOn,
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.amount} name={"amount"}>
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};
